// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.accordion.sub-accordion .header:hover {
  cursor: pointer;
}
.accordion.sub-accordion .body {
  background-color: #ece9dd;
  overflow: visible;
}
.accordion .panel .header {
  display: flex;
  align-items: center;
}
.accordion .panel .header p {
  display: flex;
  align-items: center;
  width: 95%;
}
.accordion .panel .header:hover {
  cursor: pointer;
}
.accordion .panel .body {
  background-color: #f4f2ea;
  overflow: visible;
}
.accordion .header button {
  background-color: transparent;
  outline: none;
  border: none;
  transform: translate(0, 0);
}
.accordion .header button:hover,
.accordion .header button:active,
.accordion .header button:focus {
  outline: 1px solid;
  outline: auto -webkit-focus-ring-color;
  outline-color: #b39841;
}
`, "",{"version":3,"sources":["webpack://./node_modules/proceduralsystem-clientcomponents/components/accordion/accordion.component.less"],"names":[],"mappings":"AAGI;EAEQ,eAAA;AAHZ;AACI;EAMQ,yBAAA;EACA,iBAAA;AAJZ;AAJA;EAcU,aAAA;EACA,mBAAA;AAPV;AARA;EAiBY,aAAA;EACA,mBAAA;EACA,UAAA;AANZ;AAQU;EACE,eAAA;AANZ;AAhBA;EA2BY,yBAAA;EACA,iBAAA;AARZ;AApBA;EAiCQ,6BAAA;EACA,aAAA;EACA,YAAA;EACA,0BAAA;AAVR;AA1BA;;;EA0CQ,kBAAA;EACA,sCAAA;EACA,sBAAA;AAXR","sourcesContent":["@import (reference) \"../../styles/variables.less\";\n\n.accordion {\n    &.sub-accordion {\n        .header:hover {\n            cursor: pointer;\n        }\n\n        .body {\n            background-color: @neutral-background-light;\n            overflow: visible;\n        }\n    }\n\n    .panel {\n        .header {\n          display: flex;\n          align-items: center;\n          p {\n            display: flex;\n            align-items: center;\n            width: 95%;\n          }\n          &:hover {\n            cursor: pointer;\n          }\n        }\n\n        .body {\n            background-color: @primary-40;\n            overflow: visible;\n        }\n    }\n\n    .header button {\n        background-color: transparent;\n        outline: none;\n        border: none;\n        transform: translate(0,0);\n    }\n\n    .header button:hover,\n    .header button:active,\n    .header button:focus {\n        outline: 1px solid;\n        outline: auto -webkit-focus-ring-color;\n        outline-color: @primary-90;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
